var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-field"},[_c('i',{staticClass:"material-icons prefix"},[_vm._v(_vm._s(_vm.icon))]),_c('input',{attrs:{"type":_vm.type,"id":_vm.id}}),_c('label',{attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }